export default {
  storeCategories: 'تصنيفات المتجر',
  storeCategory: 'تصنيف المتجر',
  add: 'إضافة تصنيف',
  update: 'تعديل التصنيف',
  details: 'تفاصيل التصنيف'
}
